import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { SideMenuToastMessagesService } from 'Angular/features/components/toast-messages/side-menu-toast-messages-service';

import { IconModule } from '../../directives/icon/icon.module';

/**
 * Toast outlet for SideMenuToastMessagesService; rendered inside the side menu so its toasts show
 * on every page that has a side menu.
 */
@Component({
    selector: 'ycn-side-menu-toast-messages',
    templateUrl: './toast-messages.template.html',
    standalone: true,
    imports: [CommonModule, IconModule],
})
export class SideMenuToastMessagesComponent {
    @Input() containerClass: string = 'toast toast-bottom-left flex-column';

    @Input() containerStyle: string = 'position: fixed; z-index: 2000';

    constructor(protected toastMessageService: SideMenuToastMessagesService) {}
}
